module.exports = __webpack_public_path__ + "static/mobile-hero-2dc196aecf37875d32ed58801f0d0010.webp";